import { ListOfficerFacade } from '@shared/feature/list-officer';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { Component, ContentChild, OnDestroy, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { AppConfig } from '@shared/utils/app-config';
import { MenuItemsService } from '@shared/utils/menu-items';
import { PreviewUserHeadingServiceBase } from '../../services/preview-user-heading/preview-user-heading.service';
import { filter, map, Observable, takeUntil } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutSharedComponent } from '../layout-shared/layout-shared.component';
import { UserRole } from '@shared/utils/base-auth';

@Component({
  selector: 'feature-page-layout-layout-two',
  templateUrl: './layout-two.component.html',
  styleUrls: ['./layout-two.component.css'],
  standalone: false,
})
export class LayoutTwoComponent extends LayoutSharedComponent implements OnInit, OnDestroy {
  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;

  constructor(
    public menuService: MenuItemsService,
    public appConfig: AppConfig,
    private listOfficerFacade: ListOfficerFacade,
    private agencyDetailsFacade: AgencyDetailsFacade,
    private router: Router,
    user: PreviewUserHeadingServiceBase,
    renderer: Renderer2
  ) {
    super(user, renderer);
  }

  ngOnInit(): void {
    this.menuService
      .getMenuItems()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((x) => {
        this.menuItems = x;
        this.isLoading = false;
      });

    if (this.favIcon) {
      this.favIcon.href = this.appConfig.statics.favicon;
    }
    this.listOfficerFacade.listOfficer();
    this.agencyDetailsFacade.fetchAgencyCategories();
    this.agencyDetailsFacade.fetchAgencySettings();

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((event: NavigationEnd) => {
        const isFullScreenParam = this.router.parseUrl(event.url).queryParams['isFullScreen'];
        this.isFullScreen = isFullScreenParam === 'True';
      });

    const isFullScreenParam = this.router.parseUrl(this.router.url).queryParams['isFullScreen'];
    const isCurrentUrlMatchingPattern = this.URL_PATTERN.test(this.router.url);
    if (isCurrentUrlMatchingPattern && isFullScreenParam === 'True') {
      this.isFullScreen = true;
    }
  }

  canAccessOwnProfile(): Observable<boolean> {
    return this.user.getUserRole().pipe(map((role: UserRole) => role === UserRole.SuperAdmin || role === UserRole.HRAdmin));
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
